export const renderDotSeparator = () => <span>&#x2022;</span>;
